import React, { useState, useEffect } from "react";

interface AdminPromptEditorProps {
  initialContent: string;
  onContentChange: (content: string) => void;
  className?: string;
  placeholder?: string;
  label: string;
  description?: string;
}

const AdminPromptEditor: React.FC<AdminPromptEditorProps> = ({
  initialContent = "",
  onContentChange,
  className = "",
  placeholder = "Enter prompt text here...",
  label,
  description
}) => {
  const [content, setContent] = useState(initialContent);

  // Update content when initialContent changes
  useEffect(() => {
    if (initialContent !== content) {
      setContent(initialContent);
    }
  }, [initialContent]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newContent = e.target.value;
    setContent(newContent);
    onContentChange(newContent);
  };

  return (
    <div className="w-full space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <textarea
        value={content}
        onChange={handleChange}
        placeholder={placeholder}
        className={`w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none font-mono text-sm ${className}`}
        rows={6}
      />
      {description && (
        <p className="text-sm text-gray-500">
          {description}
        </p>
      )}
    </div>
  );
};

export default AdminPromptEditor;
